module.exports = {
	"id": "PY",
	"name": "Paraguay",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.008056,
			"11": 0.036252,
			"12": 0.004028,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012084,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.008056,
			"23": null,
			"24": null,
			"25": 0.008056,
			"26": 0.004028,
			"27": null,
			"28": null,
			"29": 0.012084,
			"30": 0.008056,
			"31": 0.04028,
			"32": 0.008056,
			"33": 0.016112,
			"34": 0.024168,
			"35": 0.016112,
			"36": 0.036252,
			"37": 0.02014,
			"38": 0.028196,
			"39": 0.036252,
			"40": 0.036252,
			"41": 0.032224,
			"42": 0.012084,
			"43": 0.068476,
			"44": 0.112784,
			"45": 0.024168,
			"46": 0.04028,
			"47": 0.048336,
			"48": 0.044308,
			"49": 1.36952,
			"50": 0.092644,
			"51": 0.366548,
			"52": 0.334324,
			"53": 19.531772,
			"54": 5.3371,
			"55": 0.044308,
			"56": 0.012084,
			"57": null
		},
		"firefox": {
			"2": 0.004028,
			"3": 0.028196,
			"4": 0.008056,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.008056,
			"11": 0.012084,
			"12": 0.012084,
			"13": 0.004028,
			"14": 0.008056,
			"15": 0.02014,
			"16": 0.008056,
			"17": 0.008056,
			"18": null,
			"19": 0.004028,
			"20": 0.008056,
			"21": null,
			"22": 0.016112,
			"23": 0.004028,
			"24": 0.008056,
			"25": 0.008056,
			"26": 0.02014,
			"27": null,
			"28": 0.008056,
			"29": 0.004028,
			"30": 0.012084,
			"31": 0.012084,
			"32": 0.012084,
			"33": 0.008056,
			"34": 0.012084,
			"35": 0.02014,
			"36": 0.012084,
			"37": 0.012084,
			"38": 0.048336,
			"39": 0.028196,
			"40": 0.02014,
			"41": 0.028196,
			"42": 0.024168,
			"43": 0.14098,
			"44": 0.028196,
			"45": 0.193344,
			"46": 0.044308,
			"47": 0.386688,
			"48": 0.277932,
			"49": 4.205232,
			"50": 0.032224,
			"51": 0.012084,
			"52": null,
			"3.5": 0.008056,
			"3.6": 0.016112
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.004028,
			"28": null,
			"29": 0.096672,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.024168,
			"34": 0.004028,
			"35": null,
			"36": 0.012084,
			"37": 0.124868,
			"38": 0.024168,
			"39": 0.008056,
			"40": 0.217512,
			"41": 0.052364,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.016112,
			"6": null,
			"7": 0.012084,
			"8": 0.052364,
			"9": 0.08056,
			"10": 0.310156,
			"3.1": null,
			"3.2": null,
			"5.1": 0.012084,
			"6.1": 0.004028,
			"7.1": 0.008056,
			"9.1": 0.213484
		},
		"ios_saf": {
			"8": 0,
			"10": 2.0048143239,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0540274262073,
			"8.1-8.4": 0.0998133806203,
			"9.0-9.2": 0.0476173925895,
			"9.3": 0.726470476686
		},
		"android": {
			"3": 0,
			"4": 0.171133395349,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0213916744186,
			"4.1": 0.617302604651,
			"4.2-4.3": 1.54325651163,
			"4.4": 3.53879413953,
			"4.4.3-4.4.4": 3.56935367442
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.251342019293,
			"9": 0.121617106109,
			"10": 0.0689163601286,
			"11": 0.818888514469,
			"5.5": null
		},
		"op_mob": {
			"0": 0.432097660101,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0120027127806
		},
		"edge": {
			"12": 0.036252,
			"13": 0.116812,
			"14": 0.205428
		},
		"ie_mob": {
			"10": 0.270888169014,
			"11": 1.10290183099
		},
		"bb": {
			"7": 0.03434475,
			"10": null
		},
		"samsung": {
			"0": 5.698242
		},
		"and_uc": {
			"0": 0.764544
		},
		"op_mini": {
			"0": 5.82157662712
		},
		"and_chr": {
			"0": 35.891661
		},
		"and_ff": {
			"0": 0.011946
		}
	},
	"total": 98.96008375
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PY.json
 ** module id = 630
 ** module chunks = 0
 **/